import { PASSWORD_RULES } from "../util/passwordRules"

// Live list of password rules, ticked off as the user types
export default function PasswordChecklist({ password, id }) {
  return (
    <ul id={id} className="list-unstyled small mb-3 ms-1" aria-live="polite">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(password)
        return (
          <li key={r.text} className={ok ? "text-success" : "text-muted"}>
            <span aria-hidden="true" className="d-inline-block me-2" style={{ width: "1em" }}>
              {ok ? "✓" : "○"}
            </span>
            {r.text}
            <span className="visually-hidden">{ok ? " — done" : " — still needed"}</span>
          </li>
        )
      })}
    </ul>
  )
}
